import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Auxiliary from '../Auxiliary';
import FlexView from 'react-flexview/lib';
import { TweenMax } from 'gsap';

import Bamhurger from './Bamhurger';
import Clown from '../../assets/images/Toolbar/clownFace.svg';
import GooglyEyes from './GooglyEyes';
import Sounds from '../../components/Sounds';

export default React.memo(function Toolbar(props) {
	let face = useRef();

	useEffect(() => {
		TweenMax.to(face, 3.0, {
			opacity: 1,
			y: -180,
			ease: 'bounce.out',
			delay: 2.5,
		});
	});

	const drawer = useSelector((state) => {
		return state.drawer;
	});

	const style = drawer ? 'none' : ' ';

	return (
		<FlexView className="Toolbar" hAlignContent="center" vAlignContent="center">
			<NavLink to="/" className="Logo" style={{ display: style }}></NavLink>
			<Bamhurger />
			<NavLink to="/menu" className="Link">
				Our Menu
			</NavLink>
			<Auxiliary>
				<GooglyEyes X={props.X} Y={props.Y} eyeSweller={props.eyeSweller} />
				<img id="Clown" ref={(el) => (face = el)} src={Clown} alt="clown"></img>
			</Auxiliary>
			<NavLink to="/about" className="Link">
				About Our Food
			</NavLink>
			<Sounds className="Link" />
		</FlexView>
	);
});
